import clsx from 'clsx'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import AiLoading from '@/components/view/atoms/loading/AiLoading'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import AiLoadingArea from '@/components/view/layouts/loading/AiLoadingArea'

export interface RewriteProgress {
  step: number
  total_steps: number
  percent: number
  message: string
  detail?: string
}

interface Props {
  progress: RewriteProgress
}

const STEPS = [
  { label: 'ページ読込', icon: IconType.PRODUCT },
  { label: 'SEO分析', icon: IconType.SEARCH },
  { label: 'AI生成', icon: IconType.AI_FILL },
  { label: '結果解析', icon: IconType.ANALYTICS },
  { label: '完了', icon: IconType.CHECK }
]

const RewriteProgressStepper = ({ progress }: Props) => {
  return (
    <AiLoadingArea type='modal'>
      <AiLoading
        description={progress.message}
        prompt={`${progress.percent}% : ${progress.detail}`}
      />
    </AiLoadingArea>
  )
  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-1.5'>
        <div className='flex items-center justify-between'>
          <Text size={14} color={TextColor.SUCCESS} weight='bold'>
            {progress.message}
          </Text>
          <Text size={14} color={TextColor.SUCCESS} weight='bold'>
            {progress.percent}%
          </Text>
        </div>
        <div className='bg-fill-tertiary h-2 overflow-hidden rounded-full'>
          <div
            className='bg-fill-success h-2 rounded-full transition-[width] duration-500'
            style={{ width: `${progress.percent}%` }}
          />
        </div>
      </div>
      {progress.detail && (
        <Text size={12} color={TextColor.SECONDARY}>
          {progress.detail}
        </Text>
      )}
      <div className='flex gap-2'>
        {STEPS.map((s, i) => {
          const stepNum = i + 1
          const isActive = progress.step === stepNum
          const isDone = progress.step > stepNum || progress.percent === 100
          return (
            <div
              key={i}
              className={clsx(
                'flex-1 rounded-lg border px-1.5 py-2.5 text-center',
                isActive
                  ? 'bg-fill-success-secondary border-success'
                  : isDone
                    ? 'bg-fill-success-secondary border-secondary'
                    : 'bg-fill-tertiary border-secondary'
              )}
            >
              <div>
                <Icon
                  type={isDone ? IconType.CHECK : s.icon}
                  color={isActive || isDone ? IconColor.SUCCESS : IconColor.SECONDARY}
                  size={16}
                />
              </div>
              <Text
                size={10}
                weight='bold'
                color={isActive || isDone ? TextColor.SUCCESS : TextColor.SECONDARY}
              >
                {s.label}
              </Text>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default RewriteProgressStepper
